import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/es'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('es')

export const ARGENTINA_TZ = 'America/Argentina/Buenos_Aires' as const
dayjs.tz.setDefault(ARGENTINA_TZ)

export default dayjs

